import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { Stack, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';

const ScanShoppingCart = ({ onScan, disabled }) => {
  const scanBufferRef = useRef('');

  useEffect(() => {
    if (disabled) return;

    const handleKeyDown = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const scanned = scanBufferRef.current.trim();
        scanBufferRef.current = '';
        if (scanned) onScan(scanned);
        return;
      }
      if (e.key === 'Escape' || e.key === 'Tab') return;
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      if (e.key.length === 1) {
        e.preventDefault();
        scanBufferRef.current += e.key;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onScan, disabled]);

  useEffect(() => {
    if (disabled) {
      scanBufferRef.current = '';
    }
  }, [disabled]);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={1}
      py={3}
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <QrCodeScannerIcon color="action" sx={{ fontSize: 40 }} />
      <Typography variant="body2" color="text.secondary">
        بارکد سبد را اسکن کنید
      </Typography>
    </Stack>
  );
};

export default ScanShoppingCart;
